export default "__VITE_ASSET__1_RuS7$4__"